/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} This_Close_Midge_RadiateInputs */

const fr_this_close_midge_radiate = /** @type {(inputs: This_Close_Midge_RadiateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nom`)
};

/**

* @param {This_Close_Midge_RadiateInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const this_close_midge_radiate = /** @type {((inputs?: This_Close_Midge_RadiateInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<This_Close_Midge_RadiateInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_this_close_midge_radiate(inputs)
});